import generateHandleActions from 'redux/state-handler';
import { restApiStates } from 'redux/redux-actions';

const apiStates = restApiStates(['mails/broadcasts'], 'broadcast');

const instantStates = [];
const storage = {};
const listValues = ['broadcasts'];

export default generateHandleActions({ apiStates, instantStates, storage, listValues });
